import React from "react";
import PropTypes from "prop-types";
const InboxIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 24}
    height={height || size || 24}
    viewBox="0 0 22 26"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
    fill={color || "var(--color-easil-gray-x-dark)"}
  >
    <title>{title}</title>
    <g fill="none" fillRule="evenodd" transform="translate(-1 2)">
      <path d="M0 0h24v24H0z" />
      <g fill={color || "var(--color-easil-gray-x-dark)"} fillRule="nonzero">
        <path d="M13.465 17l1.703-2.555A1 1 0 0 1 16 14h6a1 1 0 0 1 0 2h-5.465l-1.703 2.555A1 1 0 0 1 14 19h-4a1 1 0 0 1-.832-.445L7.465 16H2a1 1 0 1 1 0-2h6a1 1 0 0 1 .832.445L10.535 17h2.93z" />
        <path d="M21 15.236l-1.9-3.793a1 1 0 0 1 1.789-.895l2.005 4.004A1 1 0 0 1 23 15v6a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3v-6a1 1 0 0 1 .106-.448l2.017-4.028a1 1 0 1 1 1.788.896L3 15.236V21a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-5.764z" />
      </g>
      <circle
        cx="12"
        cy="6"
        r="7"
        fill={color || "var(--color-easil-gray-x-dark)"}
        stroke="#FFF"
        strokeWidth="2"
      />
      <path
        fill="#FFF"
        d="M12.95 9h-1.321V4.797l-1.297.379v-1l2.496-.864h.121z"
      />
    </g>
  </svg>
);
InboxIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default InboxIcon;
